module.exports = ".galleryCarousel .owl-carousel .thumbnail \r\n{\r\n    min-height: inherit;\r\n    max-height: 250px;\r\n}\r\n\r\na.active,\r\n.galleryCarousel .owl-carousel .thumbnail.active\r\n{\r\n    color: #fff;\r\n    background-color: #a8a191;\r\n    border-color: #a49b85;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/ms-image-gallery/ms-image-gallery.component.css
// module id = ./src/app/components/ui/ms-image-gallery/ms-image-gallery.component.css
// module chunks = main